// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2tFqA","col":"styles_col__1cJcH","fulfillmentStatus":"styles_fulfillmentStatus__2MfG7","emailCol":"styles_emailCol__1boGf"};